import { useAppStore } from "@/store";
import { useEffect, useState } from "react";

export const useLiveNoteSubscription = (noteId?: string) => {
  const { store } = useAppStore();
  const [subscribedNoteId, setSubscribedNoteId] = useState<string | undefined>();

  useEffect(() => {
    let attempts = 0;
    const maxAttempts = 5;
    let timeoutId: NodeJS.Timeout | null = null;

    const trySubscribe = () => {
      if (!noteId) return;
      attempts++;
      const subscribed = store.notes.subscribeToLiveNoteSuggestions(noteId);
      if (subscribed) {
        setSubscribedNoteId(noteId);
        return;
      }
      if (attempts < maxAttempts) {
        const delay = 250 * Math.pow(2, attempts - 1);
        timeoutId = setTimeout(trySubscribe, delay);
      }
    };

    trySubscribe();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      if (subscribedNoteId) {
        store.notes.unsubscribeFromLiveNoteSuggestions(subscribedNoteId);
        setSubscribedNoteId(undefined);
      }
    };
  }, [noteId, store.notes, subscribedNoteId]);
};
